module.exports = __webpack_public_path__ + "img/bg.00be6ce8.jpeg";